import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

type Props = {
  children: ReactNode;
};

export default function ProtectedRoute({ children }: Props) {
  const { session, loading, hasUsername, onboardingStep } = useAuth();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setTimedOut(true), 3000);
    return () => window.clearTimeout(t);
  }, []);

  if (loading && !timedOut) {
    return (
      <div style={{ background: '#0F172A', 
                    width: '100vw', 
                    height: '100vh' }} />
    );
  }

  if (!session) return <Navigate to="/" replace />;

  // Logged in but mid-onboarding (no username yet): force onboarding completion.
  if (!hasUsername) return <Navigate to={`/signup?step=${onboardingStep}`} replace />;

  return <>{children}</>;
}
